export const SectionHeading = ({ title }: { title: string }) => (
  <h2 className="text-xs font-semibold uppercase tracking-widest text-foreground-muted">
    {title}
  </h2>
);
